import { GetWorkflowsPayload } from 'app/modules/workflowButtonConfig/models';

const BASE = ['workflow-buttons'] as const;

export const WORKFLOW_BUTTON_QUERY_KEYS = {
  getWorkflowButtons: (payload: GetWorkflowsPayload) =>
    [...BASE, 'workflow-buttons', payload] as const,
  getWorkflowButton: (id: number) => [...BASE, 'workflow-button', id] as const,
};
